<template>
  <div class="person-container flex">
    <left-nav-tab
      code="personalInfo"
      @handleTabPage="handleTabPage"
    />
    <div class="content-box">
      <div class="per-msg">
        <div class="subtitle">
          信息修改
          <span class="btnback pointer" @click="handlBack">返回</span>
        </div>
        <div class="edit-info">
          <div class="row flex mt20">
            <div class="label">头像</div>
              <img
              :src="userInfo.avatarUrlShow || require('@/assets/images/head.png')"
              alt=""
            />
            <el-upload
              :multiple="false"
              :show-file-list="false"
              class="image-uploader"
              action=""
              :http-request="handleSubmitImg"
              :before-upload="beforeAvatarUpload"
            >
              <el-button class="editlabel" size="medium" type="text"
                >编辑</el-button
              >
            </el-upload>
          </div>
          <div class="row flex">
            <div class="label">昵称</div>
            <el-input
              class="w214"
              v-model="userInfo.name"
              placeholder="请输入昵称"
            ></el-input>
            <div class="tips">
              新昵称以中文或英文字母开头，限4-16个字符，一个汉字为两个字符
            </div>
          </div>
          <div class="row flex">
            <div class="label">生日</div>
            <div class="date-info">
              <el-date-picker
                class="hide-date"
                ref="endDate"
                format="yyyy-MM-dd"
                v-model="userInfo.birth"
                value-format="yyyy-MM-dd"
                type="date"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="row flex">
            <div class="label">绑定手机</div>
            <div class="info-msg">{{ userInfo.showPhone || '--' }}</div>
            <div class="editlabel" @click="handleEditPhone">编辑</div>
          </div>
          <div class="row flex">
            <div class="label">登录密码</div>
            <div class="info-msg">******</div>
            <div class="editlabel" @click="handleEditPwd">编辑</div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="btn-cancle" @click="handleCancle">取消</div>
        <div class="btn-save" @click="handleSave">保存</div>
      </div>
    </div>
    <el-dialog
      title="密码修改"
      :visible.sync="centerDialogVisible"
      width="423px"
    >
      <el-form :model="form" ref="form" class="person-box">
        <el-form-item
          prop="oldPassword"
          label="当前密码"
          class="flex mb30"
          :rules="[
            {
              required: true,
              message: '请输入当前密码',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input
            type="password"
            placeholder="请输入当前密码"
            v-model="form.oldPassword"
          ></el-input>
        </el-form-item>

        <el-form-item
          prop="newPassword"
          label="新密码"
          class="flex mb30"
          :rules="[
            {
              required: true,
              message: '密码需要包含字母和数字，且不少于6位',
              trigger: ['blur', 'change'],
            },
            { validator: validatePassword, trigger: ['blur', 'change'] },
          ]"
        >
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="form.newPassword"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="confirmPassword"
          label="确认密码"
          class="flex mb30"
          :rules="[
            {
              required: true,
              message: '两次密码输入不一致，请再次输入新密码',
              trigger: ['blur', 'change'],
            },
            { validator: validateConfirmPassword, trigger: ['blur', 'change'] },
          ]"
        >
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="form.confirmPassword"
          ></el-input>
        </el-form-item>
        <div class="btn">
          <div class="btn-cancle" @click="centerDialogVisible = false">取消</div>
          <div class="btn-save" @click="handleSubmit('form')">保存</div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="手机号修改"
      :visible.sync="phoneDialogVisible"
      @close="handleCancelPhone('phoneForm')"
      width="500px"
    >
      <el-form :model="phoneForm" ref="phoneForm" class="person-box" label-width="100px">
        <el-form-item
          prop="oldPhone"
          label="当前手机号："
        >
        <span>{{phoneForm.oldPhone}}</span>
        </el-form-item>
        <el-form-item
          prop="newPhone"
          label="新手机号："
          :rules="[{ required: true, validator: validatePhone }]">
          <el-input clearable class="w80" placeholder="请输入手机号" v-model="phoneForm.newPhone"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" class="mb30" prop="code" :rules="[{required: true, message: '请输入验证码'}]">
          <div class="rightItem">
            <el-input
              placeholder="请输入验证码"
              v-model="phoneForm.code"
            ></el-input>
            <el-button v-if='isSendCode' @click='verificationCodeEvent' class='verificationCodeBtn' :disabled='isSendCode'>{{this.isNumber+'s重新获取'}}</el-button>
            <el-button v-else @click='verificationCodeEvent' class='verificationCodeBtn' :disabled="phoneForm.newPhone === '' || isSendCode">获取验证码</el-button>
          </div>
        </el-form-item>
        <div class="btn">
          <div class="btn-cancle" @click="handleCancelPhone('phoneForm')">取消</div>
          <div class="btn-save" @click="handleUpdatePhone('phoneForm')">保存</div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import LeftNavTab from '@/components/leftNavTab'
import { getInfo, saveObj, updateUserPassword, updateMobile } from '@/api/personal'
import fetch from '@/utils/fetch'
import { mapState } from 'vuex'
import { validaCellPhone } from '@/utils/validate'
import { messageAuthentication } from '@/api/login.js'
import { config } from '@/constant/config'
export default {
  data () {
    return {
      tabPage: 0,
      currentIndex: 0,
      path: 'personalCenter',
      form: {},
      navList: ['房产预定', '酒店介绍'],
      centerDialogVisible: false,
      phoneDialogVisible: false,
      phoneForm: {},
      isSendCode: false,
      isNumber: 60,
      setIntervals: null
    }
  },
  components: {
    'left-nav-tab': LeftNavTab
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo || {}
    })
  },
  created () {
    this.moduleType = this.$route.query.moduleType
    this.getInfo()
  },
  methods: {
    verificationCodeEvent () {
      if (!validaCellPhone(this.phoneForm.newPhone)) {
        this.$message.warning('请输入正确的新手机号')
        return
      }
      this.isSendCode = true
      this.setIntervals = setInterval(() => {
        this.isNumber--
        if (this.isNumber <= 0) {
          this.isNumber = 60
          this.isSendCode = false
          clearInterval(this.setIntervals)
        }
      }, 1000)
      messageAuthentication({
        mobile: this.phoneForm.newPhone,
        asyn: '0',
        tenantId: config.TENANTID,
        merchantId: config.MERCHID
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('短信发送成功')
        } else {
          this.$message.error(res.error)
        }
      })
    },
    validatePhone (rule, value, callback) {
      if (value) {
        if (validaCellPhone(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      } else {
        callback(new Error('请输入手机号'))
      }
    },
    handleCancelPhone (formName) {
      this.$refs[formName].resetFields()
      this.phoneDialogVisible = false
      this.phoneForm = {}
    },
    validatePassword (rule, value, callback) {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/
      if (value === '' || value === null || !reg.test(value)) {
        callback(new Error('密码需包含字母和数字，且不少于6位'))
      }
      callback()
    },
    validateConfirmPassword (rule, value, callback) {
      if (value === '' || value === null || value !== this.form.newPassword) {
        callback(new Error('两次密码输入不一致，请再次输入新密码'))
      }
      callback()
    },
    handleSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.newPassword !== this.form.confirmPassword) {
            this.$message.error('新密码、确认密码不一致')
            return
          }
          this.isSaving = true
          updateUserPassword(this.form).then((result) => {
            if (result.code === 0) {
              this.$message.success('密码修改成功')
              // 跳转回个人中心页
              this.centerDialogVisible = false
              this.form = {}
              this.getInfo()
            } else {
              this.isSaving = false
              this.$message.error(result.error)
            }
          })
        }
      })
    },
    handleSave () {
      const data = {
        id: this.userInfo.id,
        avatarUrl: this.userInfo.avatarUrlShow,
        birth: this.userInfo.birth,
        name: this.userInfo.name
      }
      saveObj(data).then((res) => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.getInfo()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    handleUpdatePhone (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = {
            id: this.userInfo.id,
            newMobile: this.phoneForm.newPhone,
            code: this.phoneForm.code
          }
          updateMobile(data).then((res) => {
            if (res.code === 0) {
              this.$message.success('修改成功')
              sessionStorage.setItem('mobile', this.phoneForm.newPhone)
              this.phoneDialogVisible = false
              this.getInfo()
            } else {
              this.$message.error(res.error)
            }
          })
        }
      })
    },
    handleCancle () {
      this.$router.push({
        path: 'personalInfo',
        query: { moduleType: this.moduleType }
      })
    },
    handleEditPwd () {
      this.centerDialogVisible = true
      this.form = {
        userId: this.userInfo.id
      }
      this.$refs.form.clearValidate()
    },
    handleEditPhone () {
      this.phoneDialogVisible = true
      this.phoneForm = {
        oldPhone: this.userInfo.phone
      }
    },
    handlBack () {
      this.$router.push({
        path: 'personalInfo',
        query: { moduleType: this.moduleType }
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt10M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        this.$message.error('请上传jpg,jpeg,png或者gif格式的图片!')
      }
      if (!isLt10M) {
        this.$message.error('上传大小不能超过 1MB!')
      }
      return isJPG && isLt10M
    },
    handleSubmitImg (arg) {
      const formData = new FormData()
      formData.append('file', arg.file)
      formData.append('isOpen', 'T')
      this.fileName = arg.file.name
      fetch({
        url: '/oss/endpoint/put-img',
        method: 'post',
        data: formData
      })
        .then(res => {
          if (res.code === 0) {
            this.userInfo.avatarUrlShow = res.data.link
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleTabPage (code) {
      this.code = code
      this.$router.push({
        path: code,
        query: { moduleType: this.moduleType }
      })
    },
    changeStr (str, index, changeStr) {
      return str.substr(3, 7).replace('*')
    },
    hideCode (str, frontLen, endLen) {
      var len = str.length - frontLen - endLen
      var xing = ''
      for (var i = 0; i < len; i++) {
        xing += '*'
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
    },
    getInfo () {
      getInfo().then((res) => {
        if (res.code === 0) {
          if (!res.data.phone) {
            res.data.phone = sessionStorage.getItem('mobile')
          }
          res.data.showPhone = this.hideCode(res.data.phone, 3, 4)
          res.data.avatarUrlShow = res.data.avatarUrl
          this.$store.dispatch('setUserInfo', res.data)
          // this.userInfo = res.data
        } else {
          this.$message.error(res.error)
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.person-container {
  width: 1279px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 24px;
  .rightItem {
    display: flex;
    justify-content: space-between;
    .verificationCodeBtn {
      width: 126px;
      height: 38px;
      float: right;
      margin-left: 10px;
    }
  }
  .btn {
    justify-content: center;
    display: flex;
    cursor: pointer;
  }
  .btn-cancle {
    width: 140px;
    height: 44px;
    border: 1px solid #9b232a;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #9b232a;
  }
  .btn-save {
    width: 140px;
    height: 44px;
    background: #9b232a;
    text-align: center;
    line-height: 44px;
    margin-left: 32px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
  }
}
.content-box {
  min-height: 760px;
  z-index: 1;
  position: relative;
  width: 1050px;
  margin-left: 24px;
  background-color: #fff;
  box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
  border-radius: 8px;

  .per-msg {
    padding: 40px;
  }
  .subtitle {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    position: relative;
    justify-content: space-between;
    line-height: 26px;
    display: flex;
    color: #9b232a;
    .btnback {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 24px;
      right: 40px;
      color: #9b232a;
      width: 80px;
      height: 24px;
      border: 1px solid #9b232a;
      display: block;
      text-align: center;
      border-radius: 4px;
    }
  }
  .edit-info {
    .row {
      align-items: center;
      margin-bottom: 48px;
      .label {
        width: 88px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 21px;
        color: #9fa1b0;
        margin-right: 60px;
        text-align: right;
      }
      .tips {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #9fa1b0;
        margin-left: 16px;
      }
      .info-msg {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #424855;
      }
      .editlabel {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-left: 21px;
        cursor: pointer;
        color: #9b232a;
      }
      img {
        width: 92px;
        height: 92px;
      }
    }
  }
}
</style>
